// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"119":"56e43c8f","6306":"a4527c1b","7053":"173e0059","8703":"a4527c1b"}[chunkId] + ".chunk.css";
};